import moment from "moment";

const getFormattedDateTime = (date, countryCode) => {
	const timeFormat = "HH:mm";
	const dateFormat = getDateFormatByMarket(countryCode);
	let formattedDateTime = moment(date).format(`${dateFormat} ${timeFormat}`);
	return formattedDateTime;
};

const getDateFormatByMarket = countryCode => {
	switch (countryCode) {
		case "xx":
			return "DD/MM/YYYY";
		case "JP":
			return "MM/DD/YYYY";
		default:
			return "DD-MM-YYYY";
	}
};

export { getFormattedDateTime };
